// @flow

import React   from 'react';

const MaxLimitSends = ({ translate, hasOutOfLimit } : { translate: any, hasOutOfLimit: Boolean }) => {

  function info() {
    if (!hasOutOfLimit) { return null; };

    return (
      <div className="max-limit-box">
        <div className="header reminder--orange">
          {translate('reminder.missing')}
        </div>
        <div className="content">
          {translate('reminder.only_twice')}
        </div>
      </div>
    );
  };

  return (
    <div>
      { info() }
    </div>
  );
};

export default MaxLimitSends;



// WEBPACK FOOTER //
// ./src/components/main/InsuranceInquiry/reminder/maxLimitSends.js